export const getCustomFiltersDebounceTime = () => 500;
